import * as React from 'react';
import styled from 'styled-components';

interface IFooterLogo {
  className: string;
  style?: any;
}

export const FooterLogo: React.FC<IFooterLogo> = ({ className, style }) => {
  return (
    <StyledFooterLogo className={className} style={style}>
      <svg
        width="201"
        height="63"
        viewBox="0 0 201 63"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M99.2802 20.2479H99.1875V20.3406V23.5539C99.1875 24.1586 99.2524 24.5999 99.4868 24.9568C99.6837 25.2566 99.9932 25.4861 100.454 25.7079H95.6772C96.0026 25.4884 96.2192 25.2437 96.3561 24.9281C96.5193 24.5518 96.5646 24.0846 96.5646 23.4625V14.9721C96.5646 14.3495 96.516 13.8792 96.3511 13.5014C96.2136 13.1862 95.9982 12.942 95.6786 12.7267H101.801C103.311 12.7267 104.556 13.0575 105.422 13.6901C106.283 14.3201 106.777 15.255 106.777 16.4873C106.777 17.7196 106.283 18.6546 105.423 19.2845C104.56 19.9172 103.318 20.2479 101.814 20.2479H99.2802ZM99.2933 13.0376H99.2005V13.1303V19.8704V19.9631H99.2933H100.926C102.031 19.9631 102.849 19.613 103.389 18.9959C103.928 18.3809 104.18 17.5137 104.18 16.5004C104.18 15.4868 103.925 14.6196 103.384 14.0047C102.842 13.3878 102.024 13.0376 100.926 13.0376H99.2933ZM107.152 8.90367L107.058 8.6647L106.977 8.90806L106.319 10.8823H105.901L107.015 7.54104H107.028L107.893 9.74198L107.98 9.96157L108.066 9.74198L108.931 7.54104H108.945L110.058 10.8823H109.627L108.969 8.90806L108.888 8.6647L108.794 8.90367L107.982 10.9868H107.965L107.152 8.90367Z"
          fill="url(#paint200_linear)"
          stroke="url(#paint201_linear)"
          strokeWidth="0.185482"
        />
        <rect
          x="83.566"
          y="0.566038"
          width="34.8679"
          height="34.8679"
          stroke="url(#paint200_linear)"
          strokeWidth="1.13208"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.67467 53.3676C6.67467 53.8104 6.51564 54.1924 6.20215 54.5021C5.88832 54.8122 5.4575 54.9694 4.92136 54.9694H2.58173V51.7378H4.92136C5.4575 51.7378 5.88832 51.8963 6.2018 52.2092C6.51564 52.5225 6.67467 52.9122 6.67467 53.3676ZM9.2564 53.3676C9.2564 52.2351 8.84078 51.2831 8.0205 50.5386C7.20268 49.7965 6.15939 49.4204 4.91995 49.4204H0.0805796C0.0364022 49.4204 0 49.4564 0 49.5V62.2424C0 62.2864 0.0364022 62.322 0.0805796 62.322H2.50115C2.54533 62.322 2.58173 62.2864 2.58173 62.2424V57.2868H4.92631C6.16363 57.2868 7.20516 56.9121 8.02226 56.1731C8.84113 55.4317 9.2564 54.4882 9.2564 53.3676Z"
          fill="url(#paint203_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.8313 62.322H17.2519C17.2961 62.322 17.3325 62.2864 17.3325 62.2424V51.7378H19.6721C20.2736 51.7378 20.7684 51.8949 21.1423 52.205C21.5176 52.5158 21.6997 52.9206 21.6997 53.4423C21.6997 53.9511 21.5159 54.3478 21.1374 54.6554C20.7603 54.9631 20.2609 55.1188 19.6534 55.1188H17.4975C17.4533 55.1188 17.4169 55.1548 17.4169 55.1988V55.7219C17.4169 55.7401 17.4233 55.7576 17.435 55.7719L22.7603 62.2927C22.7755 62.3112 22.7988 62.322 22.8228 62.322H25.8106C25.8417 62.322 25.8704 62.3042 25.8838 62.2763C25.8969 62.2484 25.8926 62.2152 25.8725 62.1914L21.4901 56.985C22.2252 56.8607 22.872 56.4706 23.4137 55.8236C23.9895 55.1363 24.2814 54.3352 24.2814 53.4423C24.2814 52.2916 23.8689 51.3226 23.0554 50.5634C22.2436 49.8049 21.1434 49.4204 19.7845 49.4204H14.8313C14.7871 49.4204 14.7507 49.4564 14.7507 49.5V62.2424C14.7507 62.2864 14.7871 62.322 14.8313 62.322Z"
          fill="url(#paint204_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M33.3405 62.2424V49.5C33.3405 49.4564 33.3045 49.4204 33.2599 49.4204H30.8397C30.7952 49.4204 30.7588 49.4564 30.7588 49.5V62.2424C30.7588 62.2864 30.7952 62.322 30.8397 62.322H33.2599C33.3045 62.322 33.3405 62.2864 33.3405 62.2424Z"
          fill="url(#paint205_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M44.1156 62.7425H44.692C44.7238 62.7425 44.7521 62.7243 44.7652 62.6964L50.9486 49.5339C50.9603 49.5088 50.9581 49.4801 50.9433 49.4571C50.9285 49.4344 50.9027 49.4204 50.8754 49.4204H48.2753C48.2439 49.4204 48.2153 49.4386 48.2018 49.4669L44.3803 57.6887L40.568 49.4669C40.5545 49.4386 40.5259 49.4204 40.4945 49.4204H37.8944C37.8668 49.4204 37.8413 49.4344 37.8265 49.4574C37.8117 49.4801 37.8095 49.5091 37.8212 49.5339L44.0424 62.6964C44.0555 62.7243 44.0841 62.7425 44.1156 62.7425Z"
          fill="url(#paint206_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.7805 56.6697H57.338L58.5633 54.0531L59.7805 56.6697ZM58.8758 49H58.299C58.2675 49 58.2389 49.0182 58.2258 49.0461L52.0049 62.2089C51.9933 62.2334 51.995 62.2624 52.0099 62.2851C52.0247 62.3081 52.0502 62.3221 52.0777 62.3221H54.6779C54.7093 62.3221 54.7383 62.3039 54.7514 62.2753L56.2615 58.9871H60.8567L62.3856 62.2756C62.3987 62.3043 62.4273 62.3221 62.4587 62.3221H65.0588C65.0861 62.3221 65.1122 62.3081 65.1267 62.2854C65.1415 62.2624 65.1437 62.2337 65.132 62.2089L58.9486 49.0461C58.9355 49.0182 58.9072 49 58.8758 49Z"
          fill="url(#paint207_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M76.6421 49.4204H67.3486C67.3041 49.4204 67.2681 49.4564 67.2681 49.5V51.6582C67.2681 51.7022 67.3041 51.7378 67.3486 51.7378H70.7188V62.2424C70.7188 62.2864 70.7549 62.322 70.7994 62.322H73.22C73.2642 62.322 73.3006 62.2864 73.3006 62.2424V51.7378H76.6421C76.6867 51.7378 76.7231 51.7022 76.7231 51.6582V49.5C76.7231 49.4564 76.6867 49.4204 76.6421 49.4204Z"
          fill="url(#paint208_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M95.3063 62.2676C95.3173 62.3004 95.3484 62.3221 95.383 62.3221H97.0126C97.0384 62.3221 97.0625 62.3099 97.078 62.2893C97.0932 62.2683 97.0974 62.2414 97.089 62.2173L92.6705 49.0545C92.6596 49.0227 92.6302 49.001 92.5959 49C92.5684 49.0028 92.5316 49.0192 92.5189 49.0506L88.7295 58.5227L84.931 49.0506C84.9186 49.0192 84.8963 49.0024 84.8539 49C84.8197 49.001 84.7903 49.0227 84.7794 49.0545L80.3588 62.2173C80.3507 62.2414 80.3549 62.2683 80.3701 62.2893C80.3853 62.3099 80.4097 62.3221 80.4355 62.3221H81.9559C81.9905 62.3221 82.0213 62.3004 82.0322 62.2676L84.9886 53.5638L88.6048 62.6919C88.6168 62.7223 88.6465 62.7425 88.6797 62.7425C88.7129 62.7425 88.7426 62.7223 88.7546 62.6919L92.3613 53.5935L95.3063 62.2676Z"
          fill="url(#paint209_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M109.969 62.2424V60.8693C109.969 60.8253 109.932 60.7894 109.888 60.7894H103.927V56.5674H109.652C109.696 56.5674 109.732 56.5318 109.732 56.4878V55.1147C109.732 55.0707 109.696 55.035 109.652 55.035H103.927V50.9531H109.888C109.932 50.9531 109.969 50.9171 109.969 50.8735V49.5C109.969 49.4564 109.932 49.4204 109.888 49.4204H102.296C102.251 49.4204 102.215 49.4564 102.215 49.5V62.2424C102.215 62.2864 102.251 62.322 102.296 62.322H109.888C109.932 62.322 109.969 62.2864 109.969 62.2424Z"
          fill="url(#paint210_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M128.155 55.0724H121.925C121.881 55.0724 121.844 55.108 121.844 55.152V56.5251C121.844 56.5691 121.881 56.6051 121.925 56.6051H126.524C126.51 57.3538 126.312 58.0547 125.934 58.6895C125.543 59.346 124.985 59.8786 124.275 60.2715C123.565 60.665 122.763 60.8641 121.892 60.8641C120.984 60.8641 120.139 60.6416 119.383 60.2023C118.626 59.7634 118.021 59.154 117.585 58.3917C117.15 57.6293 116.929 56.7814 116.929 55.8714C116.929 54.9617 117.151 54.1138 117.59 53.3511C118.029 52.5884 118.635 51.9791 119.392 51.5401C120.148 51.1012 120.99 50.8784 121.892 50.8784C123.344 50.8784 124.642 51.4888 125.75 52.6925C125.779 52.7243 125.829 52.7274 125.862 52.7002L127.014 51.7472C127.048 51.7193 127.052 51.669 127.024 51.6354C126.388 50.8759 125.622 50.2854 124.745 49.8807C123.868 49.4763 122.909 49.2709 121.892 49.2709C120.694 49.2709 119.57 49.5685 118.55 50.1551C117.529 50.7418 116.71 51.5513 116.115 52.5616C115.519 53.5718 115.217 54.6855 115.217 55.8714C115.217 57.057 115.517 58.1706 116.11 59.1809C116.702 60.1908 117.52 61.0003 118.54 61.5869C119.56 62.174 120.688 62.4715 121.892 62.4715C123.122 62.4715 124.24 62.1694 125.213 61.5733C126.184 60.9776 126.939 60.1761 127.457 59.191C127.974 58.2073 128.236 57.1118 128.236 55.9353V55.152C128.236 55.108 128.2 55.0724 128.155 55.0724Z"
          fill="url(#paint211_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M141.63 60.7894H135.669V49.5C135.669 49.4564 135.633 49.4204 135.589 49.4204H134.038C133.994 49.4204 133.957 49.4564 133.957 49.5V62.2424C133.957 62.2864 133.994 62.322 134.038 62.322H141.63C141.675 62.322 141.711 62.2864 141.711 62.2424V60.8693C141.711 60.8253 141.675 60.7894 141.63 60.7894Z"
          fill="url(#paint212_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M154.717 49.4204H147.125C147.08 49.4204 147.044 49.4564 147.044 49.5V62.2424C147.044 62.2864 147.08 62.322 147.125 62.322H154.717C154.761 62.322 154.797 62.2864 154.797 62.2424V60.8693C154.797 60.8253 154.761 60.7894 154.717 60.7894H148.756V56.5674H154.48C154.525 56.5674 154.561 56.5318 154.561 56.4878V55.1147C154.561 55.0707 154.525 55.035 154.48 55.035H148.756V50.9531H154.717C154.761 50.9531 154.797 50.9171 154.797 50.8735V49.5C154.797 49.4564 154.761 49.4204 154.717 49.4204Z"
          fill="url(#paint213_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M166.225 56.844C167.128 56.8055 167.899 56.456 168.519 55.8044C169.177 55.1136 169.51 54.2528 169.51 53.246C169.51 52.145 169.125 51.222 168.365 50.5026C167.606 49.7843 166.561 49.4204 165.26 49.4204H161.062C161.018 49.4204 160.982 49.4564 160.982 49.5V62.2424C160.982 62.2864 161.018 62.322 161.062 62.322H162.613C162.657 62.322 162.694 62.2864 162.694 62.2424V50.9531H165.128C165.924 50.9531 166.576 51.1647 167.065 51.5827C167.551 51.9979 167.798 52.5577 167.798 53.246C167.798 53.9347 167.551 54.4945 167.065 54.909C166.575 55.3273 165.924 55.5393 165.128 55.5393H163.19C163.158 55.5393 163.13 55.5571 163.116 55.585C163.103 55.613 163.108 55.6462 163.128 55.6703L168.706 62.2934C168.721 62.3116 168.744 62.322 168.768 62.322H170.725C170.756 62.322 170.784 62.3042 170.798 62.2759C170.811 62.248 170.807 62.2148 170.787 62.1911L166.225 56.844Z"
          fill="url(#paint214_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M183.405 49.4204H175.813C175.769 49.4204 175.732 49.4564 175.732 49.5V62.2424C175.732 62.2864 175.769 62.322 175.813 62.322H183.405C183.449 62.322 183.486 62.2864 183.486 62.2424V60.8693C183.486 60.8253 183.449 60.7894 183.405 60.7894H177.444V56.5674H183.169C183.213 56.5674 183.249 56.5318 183.249 56.4878V55.1147C183.249 55.0707 183.213 55.035 183.169 55.035H177.444V50.9531H183.405C183.449 50.9531 183.486 50.9171 183.486 50.8735V49.5C183.486 49.4564 183.449 49.4204 183.405 49.4204Z"
          fill="url(#paint215_linear)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M200.283 49.4204H198.733C198.688 49.4204 198.652 49.4564 198.652 49.5V58.6081L189.81 49.0261C189.788 49.002 189.752 48.9936 189.722 49.0052C189.691 49.017 189.67 49.0467 189.67 49.0796V62.2424C189.67 62.2864 189.706 62.322 189.751 62.322H191.301C191.346 62.322 191.382 62.2864 191.382 62.2424V53.1343L200.223 62.7163C200.239 62.7334 200.261 62.7425 200.283 62.7425C200.293 62.7425 200.302 62.7407 200.312 62.7372C200.343 62.7254 200.364 62.6957 200.364 62.6628V49.5C200.364 49.4564 200.328 49.4204 200.283 49.4204Z"
          fill="url(#paint216_linear)"
        />
        <defs>
          <linearGradient
            id="paint200_linear"
            x1="100.445"
            y1="25.632"
            x2="100.445"
            y2="7.4483"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#834628" />
            <stop offset="0.34375" stopColor="#824528" />
            <stop offset="0.572917" stopColor="#D7A87C" />
            <stop offset="0.791667" stopColor="#9C603F" />
            <stop offset="1" stopColor="#9A5E3D" />
          </linearGradient>
          <linearGradient
            id="paint201_linear"
            x1="100.445"
            y1="25.632"
            x2="100.445"
            y2="7.4483"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#834628" />
            <stop offset="0.34375" stopColor="#824528" />
            <stop offset="0.572917" stopColor="#D7A87C" />
            <stop offset="0.791667" stopColor="#9C603F" />
            <stop offset="1" stopColor="#9A5E3D" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="95.2613"
            y1="35.6692"
            x2="95.2613"
            y2="0"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#834628" />
            <stop offset="0.34375" stopColor="#824528" />
            <stop offset="0.572917" stopColor="#D7A87C" />
            <stop offset="0.791667" stopColor="#9C603F" />
            <stop offset="1" stopColor="#9A5E3D" />
          </linearGradient>
          <linearGradient
            id="paint203_linear"
            x1="4.6282"
            y1="49.4204"
            x2="4.6282"
            y2="62.322"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint204_linear"
            x1="20.321"
            y1="49.4204"
            x2="20.321"
            y2="62.322"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint205_linear"
            x1="32.0497"
            y1="49.4204"
            x2="32.0497"
            y2="62.322"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint206_linear"
            x1="44.3849"
            y1="49.4204"
            x2="44.3849"
            y2="62.7425"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint207_linear"
            x1="58.5684"
            y1="49"
            x2="58.5684"
            y2="62.3221"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint208_linear"
            x1="71.9956"
            y1="49.4204"
            x2="71.9956"
            y2="62.322"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint209_linear"
            x1="88.724"
            y1="49"
            x2="88.724"
            y2="62.7425"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint210_linear"
            x1="106.092"
            y1="49.4204"
            x2="106.092"
            y2="62.322"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint211_linear"
            x1="121.726"
            y1="49.2709"
            x2="121.726"
            y2="62.4715"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint212_linear"
            x1="137.834"
            y1="49.4204"
            x2="137.834"
            y2="62.322"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint213_linear"
            x1="150.921"
            y1="49.4204"
            x2="150.921"
            y2="62.322"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint214_linear"
            x1="165.894"
            y1="49.4204"
            x2="165.894"
            y2="62.322"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint215_linear"
            x1="179.609"
            y1="49.4204"
            x2="179.609"
            y2="62.322"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
          <linearGradient
            id="paint216_linear"
            x1="195.017"
            y1="49.0001"
            x2="195.017"
            y2="62.7425"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D69568" />
            <stop offset="0.1875" stopColor="#E2AC7E" />
            <stop offset="1" stopColor="#C88458" />
          </linearGradient>
        </defs>
      </svg>
    </StyledFooterLogo>
  );
};

const StyledFooterLogo = styled.div``;
